import { THEMES_ACTION as ACTION_TYPE } from '../types/actionTypes';
const reducer = (state, action) => {
  const {
    type,
    payload
  } = action;
  switch (type) {
    case ACTION_TYPE.SET_INITIAL_THEMES:
      {
        if (!('initialThemes' in payload && payload.initialThemes !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          initialThemes: payload.initialThemes
        });
      }
    case ACTION_TYPE.SET_THEMES:
      {
        if (!('themes' in payload && payload.themes !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          themes: payload.themes
        });
      }
    case ACTION_TYPE.SET_KEYWORDS:
      {
        if (!('keywords' in payload && payload.keywords !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          keywords: payload.keywords
        });
      }
    case ACTION_TYPE.SET_KEYWORDS_LOADING:
      {
        if (!('keywordsLoading' in payload && payload.keywordsLoading !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          keywordsLoading: payload.keywordsLoading
        });
      }
    case ACTION_TYPE.SET_KEYWORDS_ERROR:
      {
        if (!('keywordsError' in payload && payload.keywordsError !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          keywordsError: payload.keywordsError
        });
      }
    case ACTION_TYPE.SET_THEMES_LOADING:
      {
        if (!('themesLoading' in payload && payload.themesLoading !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          themesLoading: payload.themesLoading
        });
      }
    case ACTION_TYPE.SET_THEMES_ERROR:
      {
        if (!('themesError' in payload && payload.themesError !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          themesError: payload.themesError
        });
      }
    case ACTION_TYPE.ADD_THEME:
      {
        if (!('theme' in payload && payload.theme !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          themes: [...state.themes, payload.theme]
        });
      }
    case ACTION_TYPE.SET_THEMES_CHANGED:
      {
        if (!('themesChanged' in payload && payload.themesChanged !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          themesChanged: payload.themesChanged
        });
      }
    case ACTION_TYPE.SET_THEMES_ADDED:
      {
        if (!('themesAdded' in payload && payload.themesAdded !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          themesAdded: payload.themesAdded
        });
      }
    case ACTION_TYPE.SET_THEMES_DELETED:
      {
        if (!('themesDeleted' in payload && payload.themesDeleted !== undefined)) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          themesDeleted: payload.themesDeleted
        });
      }
    // sometimes we need to update multiple state values at once
    case ACTION_TYPE.SET_MULTIPLE:
      {
        return Object.assign(Object.assign({}, state), payload);
      }
    default:
      {
        break;
      }
  }
  throw new Error(`Unknown action: ${type}`);
};
export default reducer;